module.exports = __webpack_public_path__ + "static/media/ourGoalPhoto.f5913a36.jpeg";